import api from './api';
import { AccountListResponse, AccountDetailResponse, AccountFormData } from '../types/account';

export const accountService = {
    // GET /api/site/accounts?page=1&limit=10&search=...
    list: async (params?: {
        page?: number;
        limit?: number;
        search?: string;
    }): Promise<AccountListResponse> => {
        const response = await api.get('accounts', { params });
        return response.data;
    },

    // GET /api/site/accounts/:id
    getById: async (id: string): Promise<AccountDetailResponse> => {
        const response = await api.get(`accounts/${id}`);
        return response.data;
    },

    // POST /api/site/accounts
    create: async (data: AccountFormData): Promise<AccountDetailResponse> => {
        const response = await api.post('accounts', data);
        return response.data;
    },

    // PUT /api/site/accounts/:id
    update: async (id: string, data: Partial<AccountFormData>): Promise<AccountDetailResponse> => {
        const response = await api.put(`accounts/${id}`, data);
        return response.data;
    },

    // DELETE /api/site/accounts/:id  (soft delete)
    delete: async (id: string): Promise<{ success: boolean; message?: string }> => {
        const response = await api.delete(`accounts/${id}`);
        return response.data;
    },

    // PATCH /api/site/accounts/:id/toggle
    toggleStatus: async (id: string): Promise<AccountDetailResponse> => {
        const response = await api.patch(`accounts/${id}/toggle`);
        return response.data;
    },
};
